var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndoDisableBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "4 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#______src_components_common_betArea_svg_UndoDisableBtn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#______src_components_common_betArea_svg_UndoDisableBtn_svg__b)",
    fillOpacity: 0.85,
    d: "M4 50C4 22.386 26.386 0 54 0s50 22.386 50 50-22.386 50-50 50S4 77.614 4 50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeWidth: 2,
    d: "M5 50C5 22.938 26.938 1 54 1s49 21.938 49 49-21.938 49-49 49S5 77.062 5 50Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#565656",
    d: "M59.791 36.75h-16.77l2.812-2.812a2.603 2.603 0 0 0 0-3.688 2.603 2.603 0 0 0-3.688 0l-7.292 7.292a2.603 2.603 0 0 0 0 3.687l7.292 7.292c.5.5 1.167.77 1.833.77.667 0 1.334-.25 1.834-.77a2.603 2.603 0 0 0 0-3.688l-2.875-2.875H59.77c6.604 0 11.98 5.375 11.98 11.98 0 6.604-5.376 11.979-11.98 11.979H43.103a2.605 2.605 0 0 0 0 5.208H59.77c9.48 0 17.188-7.708 17.188-17.187S69.249 36.75 59.77 36.75z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_components_common_betArea_svg_UndoDisableBtn_svg__b",
    x1: 4,
    x2: 104,
    y1: 0,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221E1D"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "______src_components_common_betArea_svg_UndoDisableBtn_svg__a",
    width: 108,
    height: 108,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6524_250179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6524_250179",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoDisableBtn);
export default __webpack_public_path__ + "static/media/UndoDisableBtn.cb83a324937ff3ac67070260d86f1108.svg";
export { ForwardRef as ReactComponent };